import type { JSX } from 'preact';

const ICONS: Record<string, string[]> = {
  hash: ['M4 9h16M4 15h16M10 3 8 21M16 3l-2 18'],
  volume: ['M11 5 6 9H2v6h4l5 4V5Z', 'M15.5 8.5a5 5 0 0 1 0 7', 'M18.5 5.5a9 9 0 0 1 0 13'],
  announcement: ['M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1Z', 'M14 8a6 6 0 0 1 0 8', 'M17 5a10 10 0 0 1 0 14'],
  forum: ['M4 4h16v12H8l-4 4Z', 'M8 8h8M8 11h5'],
  chevronDown: ['m6 9 6 6 6-6'],
  chevronRight: ['m9 6 6 6-6 6'],
  chevronLeft: ['m15 6-6 6 6 6'],
  chevronUp: ['m6 15 6-6 6 6'],
  plus: ['M12 5v14M5 12h14'],
  minus: ['M5 12h14'],
  settings: ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z', 'M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.88-.34 1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1-1.55 1.7 1.7 0 0 0-1.88.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.55-1 1.7 1.7 0 0 0-.34-1.88l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6h.09A1.7 1.7 0 0 0 10.1 3.05V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.88-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9v.09a1.7 1.7 0 0 0 1.55 1H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1Z'],
  mic: ['M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z', 'M19 10v2a7 7 0 0 1-14 0v-2M12 19v3'],
  micOff: ['m2 2 20 20', 'M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V5a3 3 0 0 0-5.94-.6', 'M17 16.95A7 7 0 0 1 5 12v-2M12 19v3'],
  headphones: ['M3 14v-2a9 9 0 0 1 18 0v2', 'M3 14h4v6H5a2 2 0 0 1-2-2v-4ZM21 14h-4v6h2a2 2 0 0 0 2-2v-4Z'],
  headphoneOff: ['m2 2 20 20', 'M21 14v-2a9 9 0 0 0-14-7.5M3 14v-2a9 9 0 0 1 2-5.7', 'M3 14h4v6H5a2 2 0 0 1-2-2v-4ZM21 14h-4v6h2a2 2 0 0 0 2-2v-4Z'],
  search: ['M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z', 'm21 21-4.35-4.35'],
  pin: ['M12 17v5', 'M5 9V4h14v5l-3 4v5H8v-5Z'],
  users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M22 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  user: ['M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'],
  thread: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z', 'M8 8h8M8 12h5'],
  smile: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M8 14s1.5 2 4 2 4-2 4-2', 'M9 9h.01M15 9h.01'],
  send: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
  image: ['M3 3h18v18H3Z', 'M3 16l5-5 4 4 3-3 6 6', 'M15 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'],
  file: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z', 'M14 2v6h6'],
  lock: ['M5 11h14v10H5Z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  unlock: ['M5 11h14v10H5Z', 'M8 11V7a4 4 0 0 1 7.7-1.5'],
  shield: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z'],
  crown: ['M2 20h20', 'm2 8 5 4 5-8 5 8 5-4-2 9H4Z'],
  more: ['M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z', 'M19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z', 'M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'],
  reply: ['M9 17l-6-6 6-6', 'M3 11h11a5 5 0 0 1 5 5v3'],
  edit: ['M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z'],
  trash: ['M3 6h18M8 6V4h8v2M19 6l-1 15H6L5 6', 'M10 11v6M14 11v6'],
  close: ['M18 6 6 18M6 6l12 12'],
  home: ['M3 10.5 12 3l9 7.5', 'M5 9v12h14V9', 'M9 21v-7h6v7'],
  compass: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'm16 8-2.5 5.5L8 16l2.5-5.5Z'],
  friends: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M19 8v6M22 11h-6'],
  bell: ['M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9', 'M13.7 21a2 2 0 0 1-3.4 0'],
  bookmark: ['M19 21 12 16 5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z'],
  arrowUp: ['M12 19V5M5 12l7-7 7 7'],
  arrowDown: ['M12 5v14M19 12l-7 7-7-7'],
  award: ['M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z', 'm8.2 13.9-1.7 8.1L12 19l5.5 3-1.7-8.1'],
  poll: ['M3 3v18h18', 'M7 14v4M12 8v10M17 11v7'],
  slash: ['M14 3 10 21', 'M4 12h3M17 12h3'],
  copy: ['M8 8h12v12H8Z', 'M16 8V4H4v12h4'],
  check: ['m4 12 5 5L20 6'],
  link: ['M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.2 1.2', 'M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.2-1.2'],
  download: ['M12 3v12M7 10l5 5 5-5M5 21h14'],
  screen: ['M3 4h18v12H3Z', 'M8 20h8M12 16v4'],
  phone: ['M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.4 2.1L8 9.7a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2Z'],
  video: ['M15 10l6-3v10l-6-3', 'M3 6h12v12H3Z'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5M21 12H9'],
  admin: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z', 'M12 8v5M12 17h.01'],
  sun: ['M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z', 'M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4'],
  moon: ['M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z'],
  filter: ['M22 3H2l8 9.5V19l4 2v-8.5Z'],
  refresh: ['M23 4v6h-6M1 20v-6h6', 'M3.5 9a9 9 0 0 1 14.9-3.4L23 10M1 14l4.6 4.4A9 9 0 0 0 20.5 15'],
  alert: ['M12 9v4M12 17h.01', 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z'],
  star: ['m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8-6.2-3.2-6.2 3.2L7 14.2 2 9.3l6.9-1Z'],
  fire: ['M12 22c5 0 8-3.5 8-8 0-3-1.5-6-4-8 .5 3-2 3.5-2 1 0-3-2-6-4-7 .5 4-4 6-4 11 0 1 .5 2 1 2.5 1-2 2.5-3 2.5-1.5 0 2-3 3-3 6 0 3 2.5 4.5 5.5 4.5Z'],
  skull: ['M12 2a9 9 0 0 0-9 9c0 3 1.5 5 4 6.5V21h10v-3.5c2.5-1.5 4-3.5 4-6.5a9 9 0 0 0-9-9Z', 'M9 12h.01M15 12h.01M9 16l1 2M15 16l-1 2'],
  robot: ['M4 8h16v12H4Z', 'M12 4v4M2 13h2M20 13h2', 'M9 12h.01M15 12h.01', 'M9 16h6'],
  menu: ['M4 6h16M4 12h16M4 18h16'],
  gavel: ['m14 13-8 8M9 7l8 8M3 21h8', 'm16 3 5 5-5 5-5-5Z'],
  eye: ['M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'],
  eyeOff: ['m2 2 20 20', 'M6.7 6.7C3.8 8.5 2 12 2 12s3.5 7 10 7a11 11 0 0 0 5.3-1.3', 'M9.9 4.2A11 11 0 0 1 12 4c6.5 0 10 7 10 7a18 18 0 0 1-2.2 3.2'],
  sticker: ['M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10l6-6V5a2 2 0 0 0-2-2Z', 'M15 21v-6h6', 'M8 8h6M8 12h4'],
  gift: ['M20 12H4v9h16Z', 'M2 7h20v5H2Z', 'M12 7v14', 'M12 7H8.5A2.5 2.5 0 1 1 11 4.5ZM12 7h3.5A2.5 2.5 0 1 0 13 4.5Z'],
  volumeLow: ['M11 5 6 9H2v6h4l5 4V5Z', 'M15.5 8.5a5 5 0 0 1 0 7'],
  bold: ['M6 4h8a4 4 0 0 1 0 8H6ZM6 12h9a4 4 0 0 1 0 8H6Z'],
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 16v-4M12 8h.01'],
  ban: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'm5 5 14 14'],
  heart: ['M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z'],
  sparkles: ['m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9ZM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8Z'],
  dice: ['M4 4h16v16H4Z', 'M8 8h.01M16 8h.01M12 12h.01M8 16h.01M16 16h.01'],
  coin: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'M12 6v12M15 9a3 3 0 0 0-6 0c0 3 6 1 6 4a3 3 0 0 1-6 0'],
  clock: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'M12 6v6l4 2'],
  folder: ['M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z'],
  volumeHigh: ['M11 5 6 9H2v6h4l5 4V5Z', 'M15.5 8.5a5 5 0 0 1 0 7', 'M18.5 5.5a9 9 0 0 1 0 13'],
};

export type IconName = keyof typeof ICONS | string;

export function Icon({ name, size = 18, class: className, strokeWidth = 2, ...rest }: { name: IconName; size?: number; class?: string; strokeWidth?: number } & JSX.SVGAttributes<SVGSVGElement>) {
  const paths = ICONS[name] ?? ICONS.info;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" class={className} aria-hidden="true" {...rest}>
      {paths!.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
}
